import * as types from "../constants/actionTypes";
import {
  getPaymentUrl,
  setReservationUrl,
  payPalProxyApi
} from "../api/payment";
import { generateAsyncAction } from "./generateAsyncAction";

export const getPaymentData = req => async dispatch => {
  dispatch({ type: types.START_RECEIVING_PAYMENT_URL });
  const getPAymentUrlAction = await generateAsyncAction({
    onFailAction: getPaymentDataFailed,
    onSuccessAction: getPaymentDataSuccess,
    asyncApiMethod: getPaymentUrl,
    request: req
  });
  return dispatch(getPAymentUrlAction);
};

const getPaymentDataSuccess = ({ payload }) => dispatch => {
  dispatch({
    type: types.GET_PAYMENT_URL_SUCCEED,
    payload: payload
  });
};

const getPaymentDataFailed = () => dispatch => {
  dispatch({
    type: types.GET_PAYMENT_URL_FAILED
  });
};

export const setReservation = req => async dispatch => {
  dispatch({ type: types.START_SETTING_RESERVATION });
  const setReservationAction = await generateAsyncAction({
    onFailAction: setReservationFailed,
    onSuccessAction: setReservationSuccess,
    asyncApiMethod: setReservationUrl,
    request: req
  });
  return dispatch(setReservationAction);
};

const setReservationSuccess = ({ payload }) => dispatch => {
  dispatch({
    type: types.SET_RESERVATION_SUCCEED,
    payload: payload
  });
};

const setReservationFailed = ({ payload }) => dispatch => {
  dispatch({
    type: types.SET_RESERVATION_FAILED,
    payload: payload
  });
};

export const payPalProxy = req => async dispatch => {
  dispatch({ type: types.START_PAYPAL_PROXY });
  const payPalProxyAction = await generateAsyncAction({
    onFailAction: payPalProxyFailed,
    onSuccessAction: payPalProxySuccess,
    asyncApiMethod: payPalProxyApi,
    request: req
  });
  return dispatch(payPalProxyAction);
};

const payPalProxySuccess = ({ payload }) => dispatch => {
  dispatch({
    type: types.PAYPAL_PROXY_SUCCEED,
    payload: payload
  });
};

const payPalProxyFailed = () => dispatch => {
  dispatch({
    type: types.PAYPAL_PROXY_FAILED
  });
};



// WEBPACK FOOTER //
// ./src/actions/paymentActions.js